import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Episode } from 'src/app/shared/models/episode';
import { Season } from 'src/app/shared/models/season';
import { Show } from 'src/app/shared/models/show';
import { ImportService } from 'src/app/shared/services/import.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';

@Component({
  selector: 'app-episode-mapper-modal',
  templateUrl: './episode-mapper-modal.component.html',
  styleUrls: ['./episode-mapper-modal.component.scss']
})
export class EpisodeMapperModalComponent implements OnInit {

  show: Show = new Show();

  unrecognizedEpisodeName: string = '';

  //options are 'select-season' or 'create-season'
  seasonSelectType: string = 'select-season';

  //options are 'select-episode' or 'create-episode'
  episodeSelectType: string = 'select-episode';

  //used when adding a new season to a show
  newSeasonName: string;
  newSeasonNumber: number;

  //used when creating a new episode to map to
  newEpisodeName: string;
  newEpisodeNumber: number;

  //used when using existing seasons to map episode
  selectedSeason: Season;

  //used when mapping the episode to an already existing episode
  mapToEpisode: Episode;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<EpisodeMapperModalComponent>, public importService: ImportService, public snackbarService: SnackBarService) {
    this.unrecognizedEpisodeName = data.unrecognizedEpisodeName;
    this.show = data.show;
  }

  ngOnInit() {
    var test = this.show;
    var test2 = this.unrecognizedEpisodeName;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  /**
   * Save episode mapping details
   */
  mapEpisode() {

    if (this.seasonSelectType == 'select-season') {
      //we are using an already existing season
      if (this.episodeSelectType == 'select-episode') {
        //we mapping to an existing episode
        this.importService.createMappedEpisode(this.mapToEpisode, this.unrecognizedEpisodeName).subscribe(
          (resMappedEpisode) => {
            //handle response
            this.snackbarService.showSnackBarMessage("Episode successfully mapped!", "Close");
            
            this.onClose();
          },
          (error) => {
            //handle error
            this.snackbarService.showSnackBarMessage("An error occur while mapping the episode.", "Close", undefined, true);
          })
      }
      else if (this.episodeSelectType == 'create-episode') {
        //we are creating new episode to map to
        //first, create the episode
        if (!this.selectedSeason || !this.newEpisodeName || !this.newEpisodeNumber) {
          this.snackbarService.showSnackBarMessage("Please provide all neccessary fields to map episode.", "Close", undefined, true);
        }
        else {
          this.importService.createNewEpisode(this.selectedSeason, this.newEpisodeName, this.newEpisodeNumber).subscribe(
            (resEpisode) => {
              //handle response
              this.importService.createMappedEpisode(resEpisode, this.unrecognizedEpisodeName).subscribe(
                (resMappedEpisode) => {
                  //handle response
                  this.snackbarService.showSnackBarMessage("Episode successfully mapped!", "Close");
                  
                  this.onClose();
                },
                (error) => {
                  //handle error
                  this.snackbarService.showSnackBarMessage("An error occur while mapping the episode.", "Close", undefined, true);
                })
            },
            (error) => {
              //handle error
              this.snackbarService.showSnackBarMessage("An error occurred while creating the new episode for the mapping process.", "Close", undefined, true);
            })
        }
      }
    }
    else if (this.seasonSelectType == 'create-season') {

      //verify all needed data if provided - throw error if not
      if (!this.show || !this.newSeasonName || !this.newSeasonNumber) {
        this.snackbarService.showSnackBarMessage("Please provide all neccessary fields to map episode.", "Close", undefined, true);
      }
      else {
        //we are first creating a new season
        this.importService.createNewSeason(this.show, this.newSeasonName, this.newSeasonNumber).subscribe(
          (resSeason) => {
            //handle response
            if (!this.newEpisodeName || !this.newEpisodeNumber) {
              this.snackbarService.showSnackBarMessage("Please provide all neccessary fields to map episode.", "Close", undefined, true);
            }
            else {
              this.importService.createNewEpisode(resSeason, this.newEpisodeName, this.newEpisodeNumber).subscribe(
                (resEpisode) => {
                  //handle response
                  this.importService.createMappedEpisode(resEpisode, this.unrecognizedEpisodeName).subscribe(
                    (resMappedEpisode) => {
                      //handle response
                      this.snackbarService.showSnackBarMessage("Episode successfully mapped!", "Close");
                      
                      this.onClose();
                    },
                    (error) => {
                      //handle error
                      this.snackbarService.showSnackBarMessage("An error occur while mapping the episode.", "Close", undefined, true);
                    })
                },
                (error) => {
                  //handle error
                  this.snackbarService.showSnackBarMessage("An error occurred while creating the new episode for the mapping process.", "Close", undefined, true);
                })
            }
          },
          (error) => {
            //handle error
            this.snackbarService.showSnackBarMessage("An error occurred while creating the new season for the mapping process.", "Close", undefined, true);
          })
      }

    }
  }

  checkForEpisodes(selectedSeason: any):boolean{

    if(selectedSeason.episodes.length < 1){
      //change radio button selection for choosing episode
      this.episodeSelectType = 'create-episode';
    }

    return selectedSeason.episodes.length < 1;
  }

}
